module.exports = __webpack_public_path__ + "static/Banner-33-f05028bcbbf94596bdf380bd40b69a92.png";